export enum InstanceStatus {
    Pending = 'pending',
    Approved = 'approved',
    Denied = 'denied',
}
